export default __webpack_public_path__ + "media/src/assets/images/purple_filled-4add6f87bd144b0da1e2a3b87052e500.png";